import Walkthrough from "components/Atoms/Walkthrough"
import { useAuthenticatedRoutes } from "hooks/useAuthenticatedRoutes"
import React from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { fsmRoutes } from "routes/fsm.routes"
import useFSMWalkthrough from "./routes/walkthrough.store"

const FieldStaffMangementPage = () => {
  const location = useLocation()

  const { state, handleJoyrideCallback } = useFSMWalkthrough()

  const validChildren = useAuthenticatedRoutes({
    routes: fsmRoutes,
    showHidden: false,
    scanDeep: false,
  })

  if (location.pathname === "/d/fsm" && validChildren.length) {
    return <Navigate to={validChildren[0].path} />
  }

  return (
    <>
      <Outlet />
      <Walkthrough
        run={state.run}
        steps={state.steps}
        callback={handleJoyrideCallback}
        stepIndex={state.stepIndex}
      />
    </>
  )
}

export default FieldStaffMangementPage
